import React from 'react';
import { Box } from '@mui/material';
import useThemeStyles from '../../hooks/useThemeStyles';

const PrivacyPolicy = () => {
  const { colors } = useThemeStyles();

  return (
    <Box
      sx={{
        backgroundColor: colors.background.primary,
        color: colors.text.primary,
        padding: '20px',
        maxWidth: '900px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        lineHeight: 1.6,
        borderRadius: '8px',
      }}
    >
      <h1>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> 05/08/2025
      </p>

      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect two types of information when you use our service:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> This includes information that can identify you,
            such as your name, email address, and any other information you provide when you
            register for an account or contact us.
          </li>
          <li>
            <strong>Non-Personal Information:</strong> This includes information that is not
            directly linked to your identity, such as your browser type, device information, and
            usage data like pages viewed and features accessed.
          </li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <p>We may use your information for the following purposes:</p>
        <ul>
          <li>To provide and maintain our services</li>
          <li>To personalize your experience and improve our website and services</li>
          <li>To send you updates, promotions, and other communications related to our service</li>
          <li>To respond to your inquiries and provide customer support</li>
          <li>To comply with legal obligations and protect our rights</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Sharing and Disclosure</h2>
        <p>
          We do not share your personal information with third parties except in the following
          cases:
        </p>
        <ul>
          <li>With your consent</li>
          <li>
            With service providers who assist in the operation of our website and services (e.g.,
            hosting, email services)
          </li>
          <li>
            To comply with legal requirements, such as responding to a subpoena or other legal
            process
          </li>
          <li>To protect the rights, property, or safety of JestView, our users, or the public</li>
        </ul>
      </section>

      <section>
        <h2>4. Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and other tracking technologies to enhance your experience on our website.
          Cookies are small files stored on your device that help us remember your preferences and
          track website activity.
        </p>
        <p>
          You can control cookie settings through your browser. However, if you disable cookies,
          some features of our site may not function properly.
        </p>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>
          We take reasonable measures to protect your personal information from unauthorized access,
          use, or disclosure. However, no method of transmission over the internet or electronic
          storage is completely secure, so we cannot guarantee absolute security.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Access, correct, or delete your personal information</li>
          <li>Withdraw consent for the processing of your data</li>
          <li>Object to certain processing activities or request restriction of processing</li>
          <li>Data portability (in certain cases)</li>
        </ul>
        <p>
          If you would like to exercise any of these rights, please contact us at [insert contact
          email].
        </p>
      </section>

      <section>
        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites or services that are not controlled
          by us. We are not responsible for the content, privacy practices, or policies of these
          third-party sites. We encourage you to read their privacy policies before providing any
          personal information.
        </p>
      </section>

      <section>
        <h2>8. Children’s Privacy</h2>
        <p>
          Our services are not intended for children under the age of 13. We do not knowingly
          collect personal information from children. If we become aware that a child under 13 has
          provided us with personal information, we will take steps to delete such information.
        </p>
      </section>

      <section>
        <h2>9. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Any changes will be posted on this
          page with an updated &quot;Effective Date.&quot; We encourage you to review this policy
          periodically for any updates.
        </p>
      </section>

      <section>
        <h2>10. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <p>
          <strong>Email:</strong> alexander@koszuta.dev
        </p>
      </section>
    </Box>
  );
};

export default PrivacyPolicy;
